import React from "react";
import {BsArrowDownUp, BsTrash} from "react-icons/bs";

function UpButton({ onclick }) {
  return (
    <button
      onClick={onclick}
      className="mr-3 text-gray-500 duration-300 ease-in-out hover:text-black-900 "
    >
      <BsArrowDownUp className="w-4 h-4" />
    </button>
  );
}

export default UpButton;
